export class BaseModel {
  createdAt: Date = new Date();
  lastUpdatedAt: Date = new Date();

  static copy(obj1: any, obj2: any) {
    Object.keys(obj1).forEach((key) => (obj1[key] = obj2[key]));
    return obj1;
  }
}
